module.exports = __webpack_public_path__ + "static/shoe-3-60e47a02d6baef39d72a3eb5cdfb78bc.png";